export const basicRoutes = [
  {
    path: '/',
    redirect: '/officialWebsite',
    component: () => import('@/views/OfficialWebsite/layout/Index.vue'),
    children: [
      {
        path: 'officialWebsite',
        name: 'OfficialWebsite',
        component: () => import('@/views/OfficialWebsite/Index.vue'),
        meta: {
          title: '官网'
        }
      },
      {
        path: 'articleList',
        name: 'ArticleList',
        component: () => import('@/views/OfficialWebsite/Article/Index.vue'),
        meta: {
          title: '文章列表',
          keepAlive: true,
          keepAliveToRouteNames: ['ArticleDetail']
        }
      },
      {
        path: 'articleDetail/:id-:slug',
        name: 'ArticleDetail',
        component: () => import('@/views/OfficialWebsite/Article/Detail/Index.vue'),
        meta: {
          title: '文章详情'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/Login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/privacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/Login/PrivacyPolicy.vue'),
    meta: {
      title: '隐私协议'
    }
  },
  {
    path: '/userPolicy',
    name: 'UserPolicy',
    component: () => import('@/views/Login/UserPolicy.vue'),
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/noPermission',
    name: 'NoPermission',
    component: () => import('@/views/NoPermission.vue'),
    meta: {
      title: '无权限'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFound',
    show: false,
    component: () => import('@/views/PageNotFound.vue'),
    meta: {
      title: '未找到'
    }
  },
  {
    path: '/mobile',
    component: () => import('@/views/Mobile/layout/Index.vue'),
    name: 'Mobile',
    redirect: '/mobile/mobileWebsite',
    children: [
      {
        path: 'mobileWebsite',
        name: 'MobileWebsite',
        component: () => import('@/views/Mobile/MobileWebsite/Index.vue'),
        meta: {
          title: '移动官网'
        }
      },
      {
        path: 'mobileArticle',
        name: 'MobileArticle',
        component: () => import('@/views/Mobile/MobileArticle/Index.vue'),
        meta: {
          title: '文章列表',
          keepAlive: true,
          keepAliveToRouteNames: ['MobileArticleDetail']
        }
      },
      {
        path: 'mobileArticleDetail/:id-:slug',
        name: 'MobileArticleDetail',
        component: () => import('@/views/Mobile/MobileArticle/Detail/Index.vue'),
        meta: {
          title: '文章详情'
        }
      }
    ]
  }
]
